export default {
  locationPrinter: function() {
    const CHAR_TRUNCAT_SIZE = 7
    const printer = (locationString) => {
      let location = locationString.split('-')

      let spreadsheetIndex = location[0]
      let spreadsheet = this.spreadsheetHeaders[spreadsheetIndex]
      let spreadsheetNameShort = spreadsheet.name.slice(0, CHAR_TRUNCAT_SIZE)

      let row = parseInt(location[1]) + 1

      if (location[2]) {
        let column = location[2]
        let columnText = ''

        try {
          columnText = this.columnHeaders[spreadsheetIndex][column].data.text
        } catch (error) {
          columnText = column + '-'
        }

        let columnTextShort = columnText.slice(0, CHAR_TRUNCAT_SIZE)

        return {
          displayName: `${spreadsheetNameShort}, ${columnTextShort}${row}`,
          fullName: `${spreadsheet.name}, ${columnText}${row}`,
        }
      }

      return {
        displayName: `${spreadsheetNameShort}, Row ${row}`,
        fullName: `${spreadsheet.name}, Row ${row}`,
      }
    }

    return printer
  },
  getLocationDatum: function(locationString) {
    return this.locator()(locationString)
  },
  locator: function() {
    const locator = (locationString) => {
      if (this.parsedData.length == 0) {
        return
      }

      let location = locationString.split('-')
      let spreadsheet = location[0]
      let row = location[1]
      let column = location[2]

      if (!column) return

      let index = parseInt(row * this.maxWidth[spreadsheet]) + parseInt(column)
      return this.parsedData[spreadsheet].data[index].data
    }

    return locator
  },
  splitIndex: function(index) {
    let split = index.split('-')
    return { spreadsheet: split[0], row: split[1] }
  },
  locationIdToLocation: ({ locationId, index }) => {
    let parsedLocation = locationId.split('-')
    let locationType = parsedLocation.shift()
    if (locationType != 'cell') parsedLocation.unshift(index || 0)
    parsedLocation = parsedLocation.join('-')
    return parsedLocation
  },
}